var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-wrapper" },
    [
      _c("div", { staticClass: "tabs-wrapper" }, [_c("TabsBar")], 1),
      _c(
        "div",
        { staticClass: "user-info" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "role",
                  rawName: "v-role",
                  value: [2, 3, 5, 7, 9, 11, 13],
                  expression: "[2, 3, 5, 7, 9, 11, 13]",
                },
              ],
              staticClass: "binding-wechat",
            },
            [
              _vm.userInfo.bindStatus === 2
                ? _c("span", { staticClass: "wechat-icon active" })
                : _c("span", {
                    staticClass: "wechat-icon inactive",
                    on: {
                      click: function ($event) {
                        return _vm.handleBindWeChat()
                      },
                    },
                  }),
            ]
          ),
          _c(
            "el-popover",
            {
              attrs: {
                "popper-class": "user-info-popover",
                placement: "bottom-end",
                width: "auto",
                trigger: "click",
              },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c("div", [
                _c("div", { staticClass: "info-content" }, [
                  _c("p", [_vm._v("Welcome," + _vm._s(_vm.userInfo.name))]),
                  _c("p", [
                    _vm._v(" Logged in as "),
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.userInfo.loginName)),
                    ]),
                  ]),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "role",
                          rawName: "v-role",
                          value: [2, 3, 13],
                          expression: "[2,3,13]",
                        },
                      ],
                      staticClass: "edit-TA",
                      on: {
                        click: function ($event) {
                          return _vm.changeTA()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-edit" }),
                      _vm._v(" Edit TA"),
                    ]
                  ),
                ]),
                _vm.userInfo.bindStatus === 2
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "role",
                            rawName: "v-role",
                            value: [2, 3, 5, 7, 9, 11, 13],
                            expression: "[2, 3, 5, 7, 9, 11, 13]",
                          },
                        ],
                        staticClass: "unbound-wechat",
                        on: {
                          click: function ($event) {
                            return _vm.unBindWeChat()
                          },
                        },
                      },
                      [_vm._v(" Unbound WeChat ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "logout-btn", on: { click: _vm.logout } },
                  [_vm._v("Sign Out")]
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "nickname",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _vm._v(" " + _vm._s(_vm.userInfo.name) + " "),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("QrcodeDialog", {
        attrs: { visible: _vm.qrcodeDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
        },
      }),
      _c("TaInfoDialog", {
        attrs: { visible: _vm.taInfoDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.taInfoDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }